<template>
  <el-dialog
    class="finance-order-package-modal"
    width="480px"
    title="发货明细"
    v-loading="loading"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <data-table :columns="columns" :list="deliveries" />
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import DataTable from '@/components/DataTable'
import moment from 'moment'
export default {
  name: 'OrderDeliveryDetailModal',
  components: { DataTable },
  mixins: [ ModalMixin ],
  data () {
    return {
      loading: false,
      deliveries: [],
      columns: [
        {
          name: '包裹',
          code: 'index',
          flexWidth: 1,
          renderFunc (val) {
            return `包裹${val || ''}`
          }
        },
        {
          name: '数量',
          code: 'quantity',
          flexWidth: 1
        },
        {
          name: '时间',
          code: 'createTime',
          flexWidth: 1,
          renderFunc (val) {
            return moment(val).format('YYYY-MM-DD HH:mm:ss')
          }
        }
      ]
    }
  },
  methods: {
    init (orderItemId, deliveries) {
      const packages = deliveries.filter(t => t.items.some(s => s.orderItemId === orderItemId)).map(t => {
        return {
          index: t.index,
          quantity: t.items.find(s => s.orderItemId === orderItemId).quantity,
          createTime: t.createTime
        }
      })
      this.deliveries = packages
      return this.open()
    }
  }
}
</script>
<style lang="stylus">
.finance-order-package-modal
  .el-dialog
    width 480px
    .el-dialog__body
      padding-top 0
      td
        padding 4px
</style>
